import { wrapElement } from '../utils/dom';

export default class ArticleBody extends HTMLDivElement {

    constructor() {
        super();
    }

    connectedCallback() {
        this.makeVideosResponsive();
        this.makeTablesResponsive();
    }

    makeVideosResponsive() {
        const videos = this.querySelectorAll('iframe[src*="youtube"],iframe[src*="youtu.be"],iframe[src*="vimeo"]');

        if (videos !== null) {

            videos.forEach(video => {
                const wrapper = video.parentNode;
                video.classList.add('embed-item');
                wrapper.classList.add('embed-responsive', 'embed-responsive-16by9');
            });
        }
    }

    makeTablesResponsive() {
        const tables = this.querySelectorAll('table');

        if (tables !== null) {
            tables.forEach(table => {
                const wrapper = table.parentNode;

                if (wrapper.classList.contains('table-responsive')) {
                    return;
                }

                // create table wrapper
                const tableWrapper = document.createElement('div');
                tableWrapper.className = 'table-responsive';

                wrapElement(table, tableWrapper);
            });
        }
    }

}

customElements.define('article-body', ArticleBody, { extends: 'div' });